export default "__VITE_ASSET__66dd9100__"